/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useState, useCallback, useMemo} from 'react';
// redux
import {useSelector} from 'react-redux';
// material
import ExpandableSection from '../../../../../material/expandablesection/expandablesection';
import ConfigController from '../../../../../material/expandablesection/controllers/configcontroller/configcontroller';
import SectionCard from '../../../../../material/expandablesection/sectioncard/sectioncard';
import SectionGroup from '../../../../../material/expandablesection/sectiongroup/sectiongroup';
import {CopySnippetField, InlineMessage} from '@insticator/insticator-ui';
// styles
import injectSheet from 'react-jss';
import styles from './trending_styles';
import {PRODUCT_TRENDING_NOW} from "../../../../../state/thunks/engagement";


/* ========== ~~~~~~~~~~ Trending Now CODE ~~~~~~~~~~ ========== */
const TrendingNowCode = injectSheet(styles)((props) => {
  const {
    engagement: {
      trendingNowUnitCode,
      trendingNowHeaderCode,
      accountProducts,
    },
  } = useSelector((state) => state);

  const [isOpened, setIsOpened] = useState(false);

  const hasTrendingNowAccess = useMemo(() =>
      accountProducts.includes(PRODUCT_TRENDING_NOW) || true
    , [accountProducts]
  )

  const handleToggle = useCallback(() => {
    setIsOpened(!isOpened)
  }, [isOpened]);

  const controller = (
    <ConfigController
      handleToggle={handleToggle}
      handleCancel={handleToggle}
      isOpened={isOpened}
      title='Trending Now'
      description={''}
      cancelTitle={'Close'}
    />
  );
  return (
    <ExpandableSection
      className={`${props.classes.trendingcode} trendingcode isDisabled-${hasTrendingNowAccess ? 'false' : 'true' }`}
      controller={controller}
      isOpened={isOpened}
      handleCancel={handleToggle}
      cancelTitle={'Close'}
    >
      <SectionCard>
        <SectionGroup>
          <CopySnippetField
            title={'Header Code'}
            description={<div className='subtitle'>Place the Trending Now code right after the {`<head>`} tag in your HTML source code.</div>}
            codeSnippet={trendingNowHeaderCode}
          />
          <div className={`codemessage`}>
            <InlineMessage
              key={'meow'}
              display={true}
              name={'headercode'}
              variant={'system'}
              icon={'exclamation-triangle'}
              title={null}
              message={
                <span>Insticator Header Code is the same for all ‘hard-coded’ insticator units – only add it to your site once.</span>}
              close={false}
              handleClose={null}/>
          </div>
          <CopySnippetField
            title={'Trending Now Code'}
            description={
              <div className='subtitle'>Place the Trending Now Unit code inside of the {`<body>`} tag in your HTML
                source code where you want the Trending Now Unit to appear in your site.
              </div>
            }
            codeSnippet={trendingNowUnitCode}
          />
          <div className={`codemessage`}>
            <InlineMessage
              key={'meow'}
              display={true}
              name={'headercode'}
              variant={'system'}
              icon={'exclamation-triangle'}
              title={null}
              message={
                <span>Make sure you replace <strong>{`{articleURL}`}</strong> and <strong>{`{extPageId}`}</strong> within the code you just copied with the actual URL of the specific page where Trending Now will live</span>}
              close={false}
              handleClose={null}/>
          </div>
        </SectionGroup>
      </SectionCard>
    </ExpandableSection>
  );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default TrendingNowCode;
